import { createContext, useContext, useState } from 'react';



const TourContext = createContext();

export const useTour = () => {
  return useContext(TourContext);
};

export const TourProvider = ({ children }) => {
  const [stepIndex, setStepIndex] = useState(0);
  const [isTourActive, setIsTourActive] = useState(false);
  const [steps, setSteps] = useState([]);
  const [isSavePopDownActive, setIsSavePopDownActive] = useState(false);
  const [isAppearanceTabOpen, setIsAppearanceTabOpen] = useState(false);
  const [isLoyaltyProgramTabOpen, setIsLoyaltyProgramTabOpen] = useState(false);

  const tourStyles = {
    options: {
      arrowColor: '#fff',
      backgroundColor: '#fff',
      beaconSize: 36,
      overlayColor: 'rgba(0, 0, 0, 0.5)',
      primaryColor: '#faca39ff',
      spotlightShadow: '0 0 15px rgba(0, 0, 0, 0.5)',
      textColor: '#000',
      width: undefined,
      zIndex: 100,
    },
    tooltip: {
      borderRadius: 10,
      boxSizing: 'border-box',
      padding: 15,
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      maxWidth: "70vw",
    },
    buttonNext: {
      backgroundColor: '#faca39ff',
      borderRadius: 4,
      color: '#000',
      outline: 'none',
      border: 'none',
      boxShadow: 'none',
      
      
    },
    buttonBack: {
      color: '#000',
      marginLeft: 'auto',
      marginRight: 5,
    },
    tooltipContent: {
      margin: '10px 40px 0px 40px',
      padding: 0,
    },
    spotlight: {
      backgroundColor: 'gray',
    },
};

  const homepageSteps =  [
    {
      target: '[data-tour="homepageScreen"]',
      content: "Welcome to the ShopHub! This is a quick tour to explain how ShopHub works and help you get set up. ",
      placement: 'center',
      disableBeacon: true

    },
    {
      target: '[data-tour="step-homepageAnalyticsCards"]',
      content: 'This is a snapshot of your current loyalty program performance.',
      placement: 'auto',
    },
    {
      target: '[data-tour="step-widgetContainer"]',
      content: 'And this is a preview for what your loyalty program currently looks like!',
      placement: 'auto',
      spotlightClicks: true,
      
    },
    {
      target: '[data-tour="step-stampCard"]',
      content: 'You can let customers earn stamps at your store to spend on awesome rewards!',
      disableScrolling: true,
      placement: 'auto',
    },
    {
      target: '[data-tour="homepageScreen"]',
      content: "Pretty cool, right? Now it's time to design your own!",
      placement: 'center',
    },

    {
      target: '[data-tour="step-brandingTab"]',
      content: "Click on branding to design your loyalty program widget.",
      placement: 'auto',
      spotlightClicks: true,
    },
  ]

const brandingSteps =  [

    {
      target: '[data-tour="step-brandingPage"]',
      content: 'The branding page is where you get to make a really stand out loyalty program.',
      disableBeacon: true,
      placement: 'center',
    },
    {
      target: '[data-tour="step9"]',
      content: 'You can choose the colors of your loyalty widget.',
      placement: 'auto',
    },
    {
      target: '[data-tour="step10"]',
      content: 'You can select your header image',
      placement: 'auto',
    },
    {
      target: '[data-tour="step11"]',
      content: 'And you can pick your stamp image!',
      placement: 'auto',      
    },
    {
      target: '[data-tour="step-brandingPage"]',
      content: 'Whenever you make any changes to your design, this save pop-up will appear.',
      placement: 'center',
    },
    {
      target: '[data-tour="step-brandingPage"]',
      content: "Now give a go at choosing your own design! Don't worry, you can always come back and change it later.",
      spotlightClicks: true,
      placement: 'center',
    },
    {
      target: '[data-tour="step-brandingPage"]',
      content: "When you are ready, click next to move on (but don't forget to save!)",
      spotlightClicks: true,
      placement: 'auto',
    },
    {
      target: '[data-tour="step-brandingPage"]',
      content: "Looking good! Now let's give your customers some ways to earn stamps.",
      placement: 'center',
    },
    {
      target: '[data-tour="step-waysToEarnTab"]',
      content: "Click on 'Ways to earn'.",
      spotlightClicks: true,
      placement: 'auto',
    },
      
]

const waysToEarnSteps =  [
    {
      target: '[data-tour="step-waysToEarnPage"]',
      content: "This is where you can choose how your customers can earn stamps.",
      disableBeacon: true,
      placement: 'center',
    },
    {
      target: '[data-tour="step-addedWaysToEarnBox"]',
      content: "The two default options are creating an account and making purchases.",
      placement: 'auto',
    },
    {
      target: '[data-tour="step-user_purchase"]',
      content: "You can set how much they need to spend to to earn each stamp. So for example, if you set it to $10, they will earn a stamp for every $10 they spend.",
      placement: 'auto',
    },
    {
      target: '[data-tour="step-availableWaysToEarnBox"]',
      content: "You can also add other ways to earn stamps. Let's try adding one. Click add on one of the options.",
      spotlightClicks: true,
      placement: 'auto',
    },
    {
      target: '[data-tour="step-availableWaysToEarnBox"]',
      content: "Now enter the required fields and click confirm.",
      spotlightClicks: true,
      placement: 'auto',
    },
    {
      target: '[data-tour="step-addedWayToEarnIndex2"]',
      content: "Great! Now your ways to earn is added here where you can edit or delete it.",
      placement: 'auto',
    },
    {
      target: '[data-tour="step-waysToEarnWidgetPreview"]',
      content: "You can test yours ways to earn by clicking on them in the preview. Try it out!",
      spotlightClicks: true,
      placement: 'auto',
    },
    {
      target: '[data-tour="step-createAccountWaysToEarnWidgetPreview"]',
      content: "Besides making purchases, each customer can only use a way to earn stamps once. When used, they will look like this.",
      placement: 'auto',
    },
    {
      target: '[data-tour="step-rewardsTab"]',
      content: "What good are stamps without rewards to spend them on? Let's set some up!",
      spotlightClicks: true,
      placement: 'auto',
    },
  ]

  const rewardsSteps =  [
    {
      target: '[data-tour="step-rewardsPage"]',
      content: "This page is where you set the rewards that your customers can redeem with their stamps.",
      disableBeacon: true,
      placement: 'auto',
    },
    {
      target: '[data-tour="step-rewardsContent"]',
      content: "You have a box for adding rewards and another for editing them.",
      placement: 'auto',
    },
    {
      target: '[data-tour="step-addRewardsBox"]',
      content: "Let's try adding a reward. Choose a reward by pressing the add button next to it.",
      spotlightClicks: true,
      placement: 'auto',
    },
    {
      target: '[data-tour="step-addRewardsInputBox"]',
      content: "Now enter the required fields and click confirm.",
      spotlightClicks: true,
      placement: 'bottom',
    },
    {
      target: '[data-tour="step-addedRewardsBox"]',
      content: "Great! Now your reward is added here where you can edit or delete it.",
      placement: 'auto',
    },
    {
      target: '[data-tour="step-rewardsPage"]',
      content: "Congratulations! You now have set up your very own loyalty program!",
      spotlightClicks: true,
      placement: 'center',
    },
    {
      target: '[data-tour="step-goLiveSwitch"]',
      content: "When you are ready to go live, click this switch. Make sure you have enabled app embeds in your Shopify theme settings!",
      spotlightClicks: true,
      placement: 'auto',
    },


  ]

function saveTourStatus(tourStatus) {
  localStorage.setItem('tourStatus', tourStatus.toString());
}


function getTourStatus() {
  return localStorage.getItem('tourStatus');
}
  


const startTour = () => {
  return; // turn back on when tour is fixed for widget appearance page changes
  let tourStatus = getTourStatus();
      if(tourStatus== '0'){
        return;
      }
  setStepIndex(0);      
  setIsTourActive(true);
};


  const stopTour = () => {
    saveTourStatus(0);
    setIsTourActive(false);

  };

  const goToStep = (index) => {
    setStepIndex(index);
  };

  const setAppearanceTab = (status) => {
    setIsAppearanceTabOpen(status);
  };

  const setLoyaltyProgramTab = (status) => {
    setIsLoyaltyProgramTabOpen(status);
  };
  

  return (
    <TourContext.Provider
      value={{
        stepIndex,
        isTourActive,
        isAppearanceTabOpen,
        isLoyaltyProgramTabOpen,
        homepageSteps,
        brandingSteps,
        waysToEarnSteps,
        rewardsSteps,
        tourStyles,
        isSavePopDownActive,
        startTour,
        stopTour,
        goToStep,
        setAppearanceTab,
        setStepIndex,
        setIsSavePopDownActive,
        setLoyaltyProgramTab,
        getTourStatus,
        saveTourStatus,

        
      }}
    >
      {children}
    </TourContext.Provider>
  );
};
